import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    const onLogout = () => setUser(false);
    window.addEventListener("dls:logout", onLogout);
    return () => window.removeEventListener("dls:logout", onLogout);
  }, []);

  const startLogin = useCallback(async (email, password) => (await api.post("/auth/login", { email, password })).data, []);

  const verifyCode = useCallback(async (ticket, code, stay) => {
    const { data } = await api.post("/auth/verify", { ticket, code, stay_logged_in: stay });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, startLogin, verifyCode, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
